import { render, staticRenderFns } from "./ThemeSettingsPage.vue?vue&type=template&id=1d036eae&scoped=true&"
import script from "./ThemeSettingsPage.vue?vue&type=script&lang=js&"
export * from "./ThemeSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSettingsPage.vue?vue&type=style&index=0&id=1d036eae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d036eae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VMain,VProgressLinear,VRadio,VRadioGroup,VSwitch})
